<script setup lang="ts">
import { CounterDecrement, CounterIncrement, Counter as CounterRoot, CounterValue } from '@/components/ui/counter'
import { ref } from 'vue'

interface TicketProps {
    id: number
    category: 'full_pass' | 'full_content' | 'digital'
    date: string
}

const props = withDefaults(
    defineProps<{
        ticket: TicketProps
        counter?: number
    }>(),
    {
        counter: 0,
    },
)
const maxTickets = 1500

const emit = defineEmits<{
    (e: 'handleTicket', ticket: TicketProps, quantity: number): void
}>()

const counter = ref(props.counter)

function handleIncrement() {
    counter.value++

    if (counter.value > maxTickets) {
        counter.value = maxTickets
    }

    emit('handleTicket', props.ticket, counter.value)
}
function handleDecrement() {
    if (counter.value > 0) {
        counter.value--
        emit('handleTicket', props.ticket, counter.value)
    }
}

function handleCounterInput() {
    if (!counter.value) counter.value = 0

    emit('handleTicket', props.ticket, counter.value)
}
</script>

<template>
    <div>
        <CounterRoot :min="0" :max="maxTickets" :counter="counter">
            <CounterDecrement @decrement="handleDecrement" />
            <CounterValue class="" v-model:counter="counter" @input="handleCounterInput" />
            <CounterIncrement @increment="handleIncrement" />
        </CounterRoot>
    </div>
</template>
